import React from 'react';
import { ClockIcon, GraduationCapIcon, TrendingUpIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const highlights = [{
  Icon: ClockIcon,
  title: 'Horario flexible',
  caption: 'Tú decides part-time o full-time'
}, {
  Icon: GraduationCapIcon,
  title: 'Capacitación incluida',
  caption: 'Te entrenamos desde cero'
}, {
  Icon: TrendingUpIcon,
  title: 'Crecimiento por desempeño',
  caption: 'Tus ingresos dependen de tus resultados'
}];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-ink" aria-labelledby="hero-title" data-id="element-115" data-mp="xaxgvsxqzynp">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/52d0ee5d-99ee-4132-8905-7a13785da3cc.jpg" alt="Dos profesionales caminando por una pasarela de vidrio en un distrito corporativo moderno" className="absolute inset-0 h-full w-full object-cover object-[72%_center] lg:object-[62%_center]" data-id="element-116" data-mp="s9gic42qkoaa" />
      <div className="absolute inset-0 bg-ink/85 sm:bg-ink/70 lg:bg-gradient-to-r lg:from-ink lg:via-ink/80 lg:to-ink/25" aria-hidden="true" data-id="element-117" data-mp="3j8sgk46tfprf" />

      <div className="relative mx-auto flex min-h-[92vh] max-w-page flex-col justify-center px-5 pb-16 pt-28 sm:px-10 sm:pb-24 sm:pt-32 lg:min-h-screen lg:px-12 lg:py-40" data-id="element-118" data-mp="3o5j2v997rhla">
        <div className="max-w-2xl" data-id="element-119" data-mp="3e84rvp627l0d">
          <p className="font-sans text-[10px] font-medium uppercase tracking-widest2 text-champagne sm:text-[11px]" data-id="element-120" data-mp="3eb91j22an8yf">
            Industria de servicios financieros
          </p>

          <h1 id="hero-title" className="mt-7 font-sans text-[2.5rem] font-light uppercase leading-[1.05] text-ivory sm:text-6xl lg:text-[4.4rem]" data-id="element-121" data-mp="35a2hij0frg0f">
            ¿Y si hay
            <br data-id="element-122" data-mp="2vgu1ra85rc9j" />
            <span className="font-serif italic normal-case text-champagne" data-id="element-123" data-mp="2hj5ejvqmbt1b">
              algo más
            </span>{' '}
            para ti?
          </h1>

          <p className="mt-8 max-w-lg font-serif text-xl italic leading-snug text-ivory/90 sm:text-2xl" data-id="element-124" data-mp="2lk8usjckvr32">
            Una nueva posibilidad puede comenzar cuando decides conocerla.
          </p>

          <p className="mt-6 max-w-lg font-sans text-[17px] font-light leading-relaxed text-steel-200 sm:text-lg" data-id="element-125" data-mp="najivs7dilh4">
            Explora una nueva posibilidad dentro de la industria de servicios
            financieros, donde podrás aprender, desarrollar nuevas habilidades y
            descubrir si este camino encaja contigo.
          </p>

          <p className="mt-5 font-sans text-[15px] font-light leading-relaxed text-steel-200/80" data-id="element-126" data-mp="161t24t6y4olw">
            Sin experiencia previa. Con capacitación y acompañamiento.
          </p>

          <ul className="mt-11 flex flex-col border-t border-ivory/15 pt-8 sm:mt-12 lg:flex-row lg:items-stretch" data-id="element-127" data-mp="114svag29vhtq">
            {highlights.map(({
            Icon,
            title,
            caption
          }, i) => <li key={title} className={`flex items-stretch ${i > 0 ? 'mt-6 lg:mt-0' : ''}`} data-id="element-128" data-mp="3lui6mj3rolho" data-mpi={i}>
                {i > 0 && <span className="mr-6 hidden w-px self-stretch bg-champagne/35 lg:block xl:mr-8" aria-hidden="true" data-id="element-129" data-mp="1xacgp6hknput" />}
                <div className={i > 0 ? 'lg:pr-2 xl:pr-4' : 'lg:pr-6 xl:pr-8'} data-id="element-130" data-mp="269r7k71ni2fu">
                  <div className="flex items-center gap-2.5" data-id="element-131" data-mp="2b195sncahox4">
                    <Icon className="h-4 w-4 flex-none text-champagne" strokeWidth={1.25} aria-hidden="true" data-id="element-132" data-mp="2b2soeklf4c22" />
                    <span className="font-sans text-[12px] font-medium uppercase tracking-[0.14em] text-ivory sm:text-[13px]" data-id="element-133" data-mp="2l1028ukeudzu">
                      {title}
                    </span>
                  </div>
                  <p className="mt-2 max-w-[15rem] font-sans text-sm font-light leading-relaxed text-steel-200/85" data-id="element-134" data-mp="2tx7nsbbn66qf">
                    {caption}
                  </p>
                </div>
              </li>)}
          </ul>

          <div className="mt-10" data-id="element-135" data-mp="4auo8pqfqxn9">
            <CtaButton label="Agendar una conversación" tone="champagne" data-id="element-136" data-mp="49t4lwvct2tx" />
            <p className="mt-5 max-w-md font-sans text-sm font-light leading-relaxed text-steel-200" data-id="element-137" data-mp="3vgngkprljrps">
              Conoce cómo funciona y decide si esta oportunidad es para ti.
            </p>
          </div>
        </div>
      </div>
    </section>;
}